import { AccountId, WalletId } from "./ids.ts";

/**
 * The system **treasury** (issuance) account — the single counterparty that
 * balances every coin mint. A `buy` debits this account and credits the user;
 * a chargeback reversal burns coin back by crediting it. Its master wallet's
 * balance is therefore the negative of all coin in circulation (fully backed,
 * by construction — no coin exists without a matching treasury debit).
 *
 * It is a real `accounts` row (seeded by migration `0005_treasury_account`) so
 * the existing FKs and the per-entry `accountId` write path treat it like any
 * tenant. It has no `account_auth` row, so it can never log in or be operated
 * over the API — coin only enters/leaves it through server-built issuance
 * postings (`BuyCoinService`, reversals), never a client request.
 *
 * The ids are fixed v7-shaped sentinels (all-zero but for the trailing nibble)
 * so they're recognizable in the ledger and stable across every environment.
 * They MUST match the literals in the seed migration — `migration.test.ts`
 * asserts they do.
 */
export const TREASURY_ACCOUNT_ID = AccountId.parse("00000000-0000-7000-8000-000000000001");

/** The treasury's master wallet — the debit leg of every mint. See {@link TREASURY_ACCOUNT_ID}. */
export const TREASURY_WALLET_ID = WalletId.parse("00000000-0000-7000-8000-000000000002");

/**
 * Sentinel email for the treasury account. Reserved — registration must never
 * hand this out (the `accounts.email` UNIQUE constraint enforces it: the seed
 * row owns it, so a `register` with this email fails closed).
 */
export const TREASURY_EMAIL = "treasury@system.ggcoin";
